class Jobs {

  constructor() {
  }

  init() {


    if($(document.body).hasClass('single-emploi') || $(document.body).hasClass('page-template-jobs')) {

        // Init Fileupload With Filepond JS
        $.fn.filepond.registerPlugin(FilePondPluginFileEncode);
        $.fn.filepond.setDefaults({
          storeAsFile: true,
          maxFileSize: '2MB',
          maxFiles: 2,
          credits: false,
          allowMultiple: true,
          labelIdle: 'Glisser/déposer mes documents ou <span class="filepond--label-action">Parcourir</span>',
          iconRemove: '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="15" height="15" rx="7.5" fill="#E1E1E1"/><line x1="10.6817" y1="4.3184" x2="4.31772" y2="10.6824" stroke="black"/><line x1="10.6816" y1="10.6817" x2="4.31764" y2="4.31772" stroke="black"/></svg>',
          stylePanelLayout: 'compact',
        });
        // Turn input element into a pond
        $('.filepond').filepond();

      // Job Apply Submit
      // remove event if already added
      $(document).off('submit.job_apply_form');
      // add event listener
      $(document).on('submit.job_apply_form', '#job_apply_form', this.submitJob);
    }

  }

  submitJob(e){

    e.preventDefault();
    e.stopPropagation();

    var formData = new FormData($('#job_apply_form').get(0));

    let busy;

    // Avoid Nervous Clicks !
    if ( busy )
      busy.abort();

    // Ajax Submit Form
    busy = $.ajax({
        type: "post",
        url: scriptsJsObject.ajaxurl,
        data: formData,
        dataType: 'json',
        contentType: false,
        cache: false,
        processData:false,

      beforeSend: function () {

      },
      success: function (response) {
        let messageDialog = $('#job_apply_updated_message');
        if (response.success === true) {
          //alert('Success !');
          $('#job_apply_form')[0].reset();
          messageDialog.addClass('is-success');
          messageDialog.find('.title').html("Votre candidature a bien été transmise !");
          messageDialog.find('.content').html("Nous ne manquerons pas de vous répondre dans les meilleurs délais.");
        } else {
          //alert('Failed !');
          messageDialog.addClass('is-error');
          messageDialog.find('.title').html("Une erreur s'est produite.");
          messageDialog.find('.content').html("Nous vous invitons à vérifier les informations saisie et tenter à nouveau l'envoi de votre candidature. Si le problème persite, merci de prendre contact avec nous via la page 'Nous contacter'");
        }
        messageDialog.get(0).showModal();
        $(window).on('keyup', function(e){
          if(e.key == "Escape") {
            messageDialog.get(0).close();
          }
        });
      },
      error: function (response) { alert('error'); },
      complete: function () { }
    });

    return false;
  }

}

export { Jobs };
